import { DamageTranslation } from '../../api/types/item'
import React from 'react'
import { DamageAttributes } from './components/DamageAttributes/DamageAttributes'
import { BaseStatModifiers } from './components/BaseStatModifiers/BaseStatModifiers'
import { SkillModifiers } from './components/SkillModifiers/SkillModifiers'
import { IEffect } from '../../api/types/effect'
import { Box, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material'
import { WeaponProfAttributes } from './components/WeaponProfAttributes/WeaponProfAttributes'

interface Props {
  effect?: IEffect
  register: any
  errors: any
}

export const EffectFormAttributes: React.FC<Props> = ({ effect, register, errors }) => {
  return (
    <>
      <Typography variant="h5">Efekt</Typography>

      {effect?.id && (
        <input type="hidden" name="effect_attributes.id" value={effect.id} ref={register()} />
      )}

      <Box sx={{ display: 'flex', marginBottom: '8px' }}>
        <FormControlLabel
          control={<Checkbox color="primary" defaultChecked={effect?.timed} />}
          label="Czasowy"
          labelPlacement="end"
          name="effect_attributes.timed"
          inputRef={register}
        />

        <TextField
          type={'number'}
          fullWidth={true}
          name="effect_attributes.duration"
          label="Czas trwania"
          variant="outlined"
          defaultValue={effect?.duration}
          inputProps={{
            ref: register(),
            step: 1,
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', marginBottom: '8px' }}>
        <TextField
          sx={{ marginRight: '8px' }}
          type={'number'}
          fullWidth={true}
          name="effect_attributes.hit"
          label="Trafienie"
          variant="outlined"
          defaultValue={effect?.hit}
          inputProps={{
            ref: register(),
          }}
        />
        <TextField
          sx={{ marginRight: '8px' }}
          type={'number'}
          fullWidth={true}
          name="effect_attributes.shield_block"
          label="Blok"
          variant="outlined"
          defaultValue={effect?.shield_block}
          inputProps={{
            ref: register(),
          }}
        />
        <TextField
          type={'number'}
          fullWidth={true}
          name="effect_attributes.dodge"
          label="Unik"
          variant="outlined"
          defaultValue={effect?.dodge}
          inputProps={{
            ref: register(),
          }}
        />
      </Box>

      {effect?.damage?.id && (
        <input
          type="hidden"
          name="effect_attributes.damage_attributes.id"
          value={effect?.damage?.id}
          ref={register()}
        />
      )}
      <DamageAttributes
        errors={errors}
        title={'Obrażenia'}
        dropdownTitle={'Dodaj obrażenia'}
        attr_name={'effect_attributes.damage'}
        translation={DamageTranslation}
        entries={Object.entries(effect?.damage || {})}
        register={register}
      />

      {effect?.damage_reduction?.id && (
        <input
          type="hidden"
          name="effect_attributes.damage_reduction_attributes.id"
          value={effect?.damage_reduction?.id}
          ref={register()}
        />
      )}
      <DamageAttributes
        errors={errors}
        title={'Redukcja obrażeń'}
        dropdownTitle={'Dodaj redukcję obrażeń'}
        attr_name={'effect_attributes.damage_reduction'}
        translation={DamageTranslation}
        entries={Object.entries(effect?.damage_reduction || {})}
        register={register}
        numberOnly={true}
      />

      <BaseStatModifiers effect={effect} register={register} />
      <SkillModifiers effect={effect} register={register} />
      <WeaponProfAttributes effect={effect} register={register} />
    </>
  )
}
